module.exports = ".she-navbar {\n  background-color: #3B3F51; }\n  .she-navbar .she-logo-default {\n    margin-top: 5px;\n    height: 65px; }\n  .she-navbar .she-logout-wrapper {\n    line-height: 30px; }\n    .she-navbar .she-logout-wrapper .she-username {\n      margin-right: 10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/layout/navbar/navbar.component.scss
// module id = 586
// module chunks = 8